import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import Header from "../../layout/Header/Header";
import MenuBotones from "../../MenuBotones";

function BotonesContenedores() {
  const { user } = useContext(AuthContext);
  const [t] = useTranslation("global");

  if (!(user.menuContenedores || user.menuContenedoresPS || user.menuContenedoresClientes)) return <Header />;

  const esCliente = user.tipo == "Cliente";

  return (
    <MenuBotones
      titulo={t("Contenedores")}
      descripcion={t("Seguimiento de contenedores, surtidos y ventas")}
      icono="fas fa-ship"
      color="#2563eb"
      secciones={[
        {
          section: t("Operación"),
          items: [
            { label: t("Contenedores"), icon: "fas fa-box", color: "#2563eb", href: "/ListadoContenedores",
              desc: t("Alta y seguimiento de contenedores"), enabled: !!user.menuContenedores },
            { label: t("Reporte de estatus"), icon: "fas fa-file-excel", color: "#15803d", href: "/ReporteEstatusCliente",
              desc: t("Excel de estatus por cliente con sus columnas"), enabled: !!user.menuContenedores },
            { label: t("Surtir"), icon: "fas fa-truck", color: "#0d9488", href: "/ListadoPendienteSurtir",
              desc: t("Contenedores pendientes de surtir"), enabled: !!user.menuSurtidos },
            { label: t("Ventas"), icon: "fas fa-receipt", color: "#16a34a", href: "/ListadoSurtidos",
              desc: t("Surtidos realizados"), enabled: !!user.menuVentas },
          ],
        },
        {
          section: t("Revalidaciones"),
          items: [
            { label: t("Revalidaciones"), icon: "fas fa-stamp", color: "#0d9488", href: "/Revalidaciones",
              desc: t("Proceso, documentos y demoras por contenedor"), enabled: !!user.menuContenedores },
            { label: t("Pagos a naviera"), icon: "fas fa-money-check-alt", color: "#d97706", href: "/PagosNaviera",
              desc: t("Pagos solicitados a navieras, monto y comprobante"), enabled: !!user.menuContenedores },
            { label: t("Cargos y cobros"), icon: "fas fa-file-invoice-dollar", color: "#16a34a", href: "/RevalidacionesCobros",
              desc: t("Cargos locales, cargos extra, demoras y garantías"), enabled: !!user.menuContenedores && !!user.menuAdmin },
          ],
        },
        {
          section: t("Clientes"),
          items: [
            { label: `${t("Contenedores")} Price Shoes`, icon: "fas fa-boxes", color: "#7c3aed", href: "/ListadoContenedoresPS",
              desc: t("Vista de contenedores Price Shoes"), enabled: !!user.menuContenedoresPS },
            { label: `${t("Contenedores")} Eliezer`, icon: "fas fa-boxes", color: "#db2777", href: "/ListadoContenedoresEliezer",
              desc: t("Vista de contenedores Eliezer"), enabled: !!user.menuContenedoresPS },
          ],
        },
        {
          section: t("Mi cuenta"),
          items: [
            { label: t("Mis Contenedores"), icon: "fas fa-box-open", color: "#2563eb", href: "/ListadoContenedoresClientes",
              desc: t("Estatus de tus contenedores"), enabled: !!user.menuContenedoresClientes && esCliente },
            { label: t("Estado de Cuenta"), icon: "fas fa-file-invoice-dollar", color: "#ea580c", href: "/EstadoCuentaClientes",
              desc: t("Cargos, pagos y saldo"), enabled: !!user.menuContenedoresClientes && esCliente },
          ],
        },
      ]}
    />
  );
}

export default BotonesContenedores;
